module.exports = {
    // title: '经开区审计管理系统',
    title: '东部新中心项目管理系统',
}
